export default __webpack_public_path__ + "static/media/nachi.edb6ed28.jpeg";